/* eslint-disable no-underscore-dangle */
// eslint-disable-next-line import/named
import { UNSAVE_ALERT_EVENTS } from '../constants/actionTypes';

export const initialState = {
  link: null,
  open: false,
  status: false,
};

const unsaveAlertReducer = (state, { type, payload }) => {
  switch (type) {
    case UNSAVE_ALERT_EVENTS.SET:
      return { ...state, ...payload };
    case UNSAVE_ALERT_EVENTS.RESET:
      return initialState;

    default:
      return state;
  }
};

export default unsaveAlertReducer;
